import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-49a13bfa"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "max-w-5xl mx-auto" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "flex flex-col my-1" }, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Title = _resolveComponent("Title");
    const _component_Form = _resolveComponent("Form");
    const _component_Table = _resolveComponent("Table");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Title, {
            msg: "ユーザ変更申請一覧",
            submsg: "Update Request"
        }),
        _hoisted_2,
        _createVNode(_component_Form, {
            handleSearch: $options.search,
            requestsList: _ctx.requestsList,
            isSysAdmin: $data.isSysAdmin
        }, null, 8, ["handleSearch", "requestsList", "isSysAdmin"]),
        _createVNode(_component_Table, {
            searchedRequests: $data.searchedRequests,
            completeRequest: $options.completeRequest,
            getUpdateReqDetails: $options.getUpdateReqDetails,
            isSysAdmin: $data.isSysAdmin
        }, null, 8, ["searchedRequests", "completeRequest", "getUpdateReqDetails", "isSysAdmin"])
    ]));
}
